import Flickity from 'flickity';
import 'flickity-imagesloaded';

// Make an index of carousels for potential use later in theme editor
const pods_carousels = {};

// The main function that actually initializes the carousels
const initPodsCarousel = ($carousel, index) => {
  const id = $carousel.attr('id');
  const $data = $carousel.data();

  let initial_index = index || 0;
  let prev_next_buttons = $data.prevNextButtons;
  let page_dots = $data.pageDots;
  let draggable = $data.draggable;
  let wrap_around = $data.wrapAround;
  let cell_align = $data.cellAlign;
  let group_cells = $data.groupCells;

  if (window.theme.breakpoints.current === 'mobile') {
    prev_next_buttons = $data.prevNextButtonsMobile;
    page_dots = $data.pageDotsMobile;
    draggable = $data.draggableMobile;
    wrap_around = $data.wrapAroundMobile;
    cell_align = $data.cellAlignMobile;
    group_cells = $data.groupCellsMobile;
  }

  if (pods_carousels[id]) {
    initial_index = pods_carousels[id].selectedIndex;
    pods_carousels[id].destroy();
    delete pods_carousels[id];
  }

  if ($carousel.children().length < 1) {
    // Don't init pointless carousels with no slides
    $carousel.addClass('AnimateOnLoad--loaded');
    return;
  }

  let all_pods_visible = true;
  const initial_offset_top = $carousel.children().eq(0).offset().top;

  // Before the carousel inits, the pods are just normal blocks floated left.
  // If there are more than will fit in the container, they will push to another line.
  // In other words, if their offset top changes, we know we have more pods than we can see at one time.
  $carousel.children().each((i, pod) => {
    if ($(pod).offset().top !== initial_offset_top) {
      all_pods_visible = false;
    }
  });

  if (all_pods_visible) {
    wrap_around = false;
    prev_next_buttons = false;
    draggable = false;
    page_dots = false;
  }

  pods_carousels[id] = new Flickity($carousel[0], {
    initialIndex: initial_index,
    prevNextButtons: prev_next_buttons,
    pageDots: page_dots,
    wrapAround: wrap_around,
    cellAlign: cell_align,
    groupCells: group_cells,
    // autoPlay: $carousel.data('autoPlay'),
    // pauseAutoPlayOnHover: $carousel.data('pauseAutoPlayOnHover'),
    dragThreshold: window.theme.flickity.dragThreshold,
    adaptiveHeight: true,
    contain: true,
    imagesLoaded: true,
    draggable,
    on: {
      ready: () => {
        $carousel.addClass('AnimateOnLoad--loaded');
      },
    },
  });
};

const initPodsCarousels = () => {
  $('[data-pods-carousel]').each((i, carousel) => {
    initPodsCarousel($(carousel));
  });
};

export {
  pods_carousels,
  initPodsCarousel,
  initPodsCarousels,
};